var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var OptionTypesList = /** @class */ (function (_super) {
    __extends(OptionTypesList, _super);
    function OptionTypesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Име на български', key: 'bg_name', filter: false, sort: false },
            { name: 'Име на английски', key: 'en_name', filter: false, sort: false },
        ];
        _this.editOptionType = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editOptionType.path.replace(':id', selectedId));
            }
        };
        return _this;
    }
    OptionTypesList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: 50, rows: 10, editAction: this.editOptionType }));
    };
    return OptionTypesList;
}(React.Component));
// @ts-ignore
export default withRouter(OptionTypesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/OptionTypes/OptionTypesList/OptionTypesList.tsx
// module id = 378
// module chunks = 0